module.exports = __webpack_public_path__ + "e7d128f2b493f8ac349978d4b1a107f0.MP3";